import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
import { deepEquals } from "./deepEquals";
/**
 * A base view class which performs a deep equals comparison instead of requiring explicitly defined equals methods.
 */
export class ViewProperties extends AbstractViewProperties {
    equals(other) {
        return deepEquals(this, other);
    }
}
//# sourceMappingURL=ViewProperties.js.map